import { render, staticRenderFns } from "./DrawerDemandsAndNeeds.vue?vue&type=template&id=515e9c6f&scoped=true&"
import script from "./DrawerDemandsAndNeeds.vue?vue&type=script&lang=js&"
export * from "./DrawerDemandsAndNeeds.vue?vue&type=script&lang=js&"
import style0 from "./DrawerDemandsAndNeeds.vue?vue&type=style&index=0&id=515e9c6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515e9c6f",
  null
  
)

export default component.exports